import React from 'react';
import axios from "../../../containers/api";
import { Link } from "react-router-dom";
import DatePicker, { utils } from "react-modern-calendar-datepicker";
import { Table } from "../../../components/table/Table";
import Config from "../../../constants/config";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import {
    Badge, Button, Card, CardBody, CardTitle,
    Modal, ModalHeader, ModalBody, ModalFooter,
    FormGroup, Label, Input, CustomInput,
    Row, Colxxو
} from "reactstrap";
import { getkalas, showCatchError, convertDate, toCurrency, toEnglishNumbers } from "../../../helpers/Utils";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

class Drafts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "1",
            fromDate: utils('fa').getToday(),
            toDate: utils('fa').getToday(),
            Drafts: [],

            DraftSearchResult: [],
            CargoId: null,
            TransportationCompanyList: [],
            TransportationCompany: null,
            selectedDraftStatus: { value: -1, text: 'همه' },
            DraftStatus: [
                { value: 0, text: 'کنسل شده' },
                { value: 1, text: 'در انتظار کد' },
                { value: 2, text: 'کد حواله دریافت شد' },
                { value: 3, text: 'صدور بارنامه' },
                { value: -1, text: 'همه' }
            ],
            FinishCargoModal: false,
            IsLoadHall: false,
            FinishDesc: "",
            PriorityList: [],
            PriorityModal: false,
            priorityMsg: "",
            ReserveList: [],
            ReserveModal: false,
            ReserveMsg: "",

        };
    }



    componentDidMount() {
        // this.SearchDraft(); 
        const { role } = this.props.memberType;
        if (['AdminSupport', 'Admin'].includes(role)) {
            this.GetAllTransportationCompany();

        }

        window.scrollTo(0, 0);
    }

    // دریافت مشتریان


    // دریافت شرکت‌های حمل
    GetAllTransportationCompany = () => {
        const { role } = this.props.memberType;
        const api = ['Organization', 'DriversAssociation', 'AssociationTransportCompanies'].includes(role)
            ? 'transportation-company-users/GetByUserId'
            : 'transportation-companies/GetAll';

        axios.get(`/api/v1/${api}`)
            .then(res => this.setState({ TransportationCompanyList: res.data.data }))
            .catch(err => this.props.showAlert(showCatchError(err), "error"));
    };

    // جستجوی بار
    SearchDraft = () => {
        const { fromDate, toDate, selectedDraftStatus, TransportationCompany } = this.state;
        const { role } = this.props.memberType;

        const searchModel = {
            FromDate: convertDate(fromDate),
            ToDate: convertDate(toDate),


            DraftStatus: selectedDraftStatus.value,
            TransportationCompanyId: null,

        };

        if (['AdminSupport', 'Admin'].includes(role)) {
            searchModel.TransportationCompanyId = TransportationCompany?.transportationCompanyId || null;
        }

        this.props.showSpinner();
        axios.post('/api/v1/drafts/SearchDraft', searchModel)
            .then(res => {
                this.props.hideSpinner();
                const data = res.data.data || [];
                this.setState({ DraftSearchResult: data });

                this.props.showAlert(
                    data.length === 0
                        ? "موردی یافت نشد"
                        : `${data.length} مورد یافت شد`,
                    data.length === 0 ? "warning" : "success"
                );
            })
            .catch(err => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(err), "error");
            });
    };

    // پاک کردن فیلترها
    clearSearch = () => {
        this.setState({

            selectedDraftStatus: { value: -1, text: 'همه' },
            fromDate: utils('fa').getToday(),
            toDate: utils('fa').getToday(),

            TransportationCompany: null,
        });
    };


    CancelDraft = (Id, DraftCode) => {
        this.props.closeSweetAlert();
        this.props.showSpinner();
        axios.post('/api/v1/drafts/CancelDraft', { Id: Id, DraftCode: DraftCode })
            .then(res => {
                this.props.hideSpinner();
                this.props.showAlert(res.data.message, "success");
                this.SearchDraft();
            })
            .catch(err => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(err), "error");
            });
    };
    CheckStatus = (DraftCode) => {
        this.props.closeSweetAlert();
        this.props.showSpinner();
        axios.get('api/v1/drafts/CheckStatus/' + DraftCode)
            .then(res => {
                this.props.hideSpinner();
                this.props.showAlert(res.data.message, "success");

            })
            .catch(err => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(err), "error");
            });
    };




    // هندلر تغییر
    selectHandleChange = (e, value, name) => {
        this.setState({ [name]: value });
    };

    closeModal = (name) => this.setState({ [name]: false });

    render() {
        const { memberType } = this.props;
        const isAdmin = ['AdminSupport', 'Admin', 'Organization', 'DriversAssociation', 'AssociationTransportCompanies'].includes(memberType.role);

        return (
            <>
                {/* هدر */}
                <Row>
                    <Colxx xxs="12">
                        <h3 className="mb-4">لیست حواله ها</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

                {/* فرم جستجو */}
                <Row>
                    <Colxx xxs="12">
                        <Card className="shadow-sm">
                            <CardBody>
                                <CardTitle className="text-primary">جستجو</CardTitle>
                                <div className="p-4 border rounded bg-light">

                                    {/* ردیف اول */}
                                    <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap gap-3 mb-3">
                                        <FormGroup className="flex-fill min-w-200">
                                            <Label>از تاریخ</Label>
                                            <DatePicker
                                                value={this.state.fromDate}
                                                onChange={d => this.setState({ fromDate: d })}
                                                inputPlaceholder="انتخاب تاریخ"
                                                shouldHighlightWeekends
                                                inputClassName="form-control"
                                                locale="fa"
                                                colorPrimary={Config.color}
                                                calendarPopperPosition="bottom"
                                            />
                                        </FormGroup>

                                        <FormGroup className="flex-fill min-w-200">
                                            <Label>تا تاریخ</Label>
                                            <DatePicker
                                                value={this.state.toDate}
                                                onChange={d => this.setState({ toDate: d })}
                                                inputPlaceholder="انتخاب تاریخ"
                                                shouldHighlightWeekends
                                                inputClassName="form-control"
                                                locale="fa"
                                                colorPrimary={Config.color}
                                                calendarPopperPosition="bottom"
                                            />
                                        </FormGroup>


                                    </div>



                                    {/* ردیف سوم */}
                                    <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap gap-3 mb-4">
                                        <FormGroup className="flex-fill min-w-200">
                                            <Label>وضعیت</Label>
                                            <Autocomplete
                                                disableClearable
                                                options={this.state.DraftStatus}
                                                value={this.state.selectedDraftStatus}
                                                getOptionLabel={opt => opt.text}
                                                onChange={(e, v) => this.selectHandleChange(e, v, "selectedDraftStatus")}
                                                renderInput={params => <TextField {...params} variant="standard" />}
                                            />
                                        </FormGroup>
                                        {isAdmin && (
                                            <FormGroup className="flex-fill min-w-200">
                                                <Label>شرکت حمل</Label>
                                                <Autocomplete
                                                    options={this.state.TransportationCompanyList}
                                                    value={this.state.TransportationCompany}
                                                    getOptionLabel={opt => opt.transportationCompanyName}
                                                    onChange={(e, v) => this.selectHandleChange(e, v, "TransportationCompany")}
                                                    renderInput={params => <TextField {...params} variant="standard" />}
                                                />
                                            </FormGroup>
                                        )}



                                        <div className="flex-fill min-w-200" />
                                    </div>

                                    {/* دکمه‌ها */}
                                    <div className="d-flex justify-content-center gap-3">
                                        <Button color="primary" size="lg" onClick={this.SearchDraft}>
                                            جستجو
                                        </Button>
                                        <Button color="secondary" size="lg" onClick={this.clearSearch}>
                                            پاک کردن
                                        </Button>
                                    </div>
                                </div>

                                {/* جدول اصلی */}
                                <div className="mt-4">
                                    <Table
                                        tableHeaders={[
                                            "شناسه",
                                            "وضعیت حواله",
                                            "تاریخ",
                                            "ساعت",
                                            "شرکت حمل",
                                            "شهر مقصد",
                                            "شهر مبدا",
                                            "مبلغ کرایه",
                                            "وزن",
                                            "نرخ کرایه",
                                            "نوع محموله",
                                            "نوع ماشین",
                                            "ابطال حواله",
                                            "بررسی وضعیت",
                                            "ثبت بارنامه",


                                        ]}
                                        tableRow={this.state.DraftSearchResult}
                                        tableData={[
                                            c => c.id,
                                            c => {
                                                const status = {
                                                    0: { color: "danger", text: "کنسل شده" },
                                                    1: { color: "primary", text: "در انتظار کد" },
                                                    2: { color: "success", text: "کد حواله دریافت شد" },
                                                    3: { color: "primary", text: "صدور بارنامه" },

                                                }[c.draftStatus] || { color: "secondary", text: "نامشخص" };
                                                return <Badge color={`outline-${status.color}`} pill>{status.text}</Badge>;
                                            },
                                            c => c.draftDate,
                                            c => c.draftTime,
                                            c => c.transportationCompanyName,
                                            c => c.senderSourceCityName,
                                            c => c.receiverDestinationCityName,

                                            c => c.freightAmount,
                                            c => c.freightRate,
                                            c => c.kalaWeight,
                                            c => c.kalaDesc,
                                            c => c.loaderTypeName,
                                            c => c.draftStatus === 2 && c.draftCode?.toString().trim() !== '' ? (
                                                <Button outline color="primary" size="sm"
                                                    onClick={() => this.props.showSweetAlert("آیا از ابطال حواله  اطمینان دارید؟", "", "danger", () => this.CancelDraft(c.id, c.draftCode))}>
                                                    ابطال حواله
                                                </Button>
                                            ) : "",
                                            c => c.draftStatus === 1 ? (
                                                <Button outline color="primary" size="sm"
                                                    onClick={() => this.CheckStatus(c.draftCode)}>
                                                    بررسی وضعیت
                                                </Button>
                                            ) : "",
                                             c => c.draftStatus === 2 && c.draftCode?.toString().trim() !== '' ? ( 
                                          /*  c => c.draftStatus === 1 ? (*/
                                               
                                                    <Link to={`/AddBill/${c.id}`}>
                                                        <Button className="btn-custom" color="primary">
                                                            ثبت بارنامه
                                                        </Button>
                                                    </Link>
                                                   
                                                
                                            ) : "",
                                        ]}
                                    />
                                </div>
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>




            </>
        );
    }
}

export default Drafts;